// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionExtend_container__N1CZt","heading":"SessionExtend_heading__tb7KN","subheading":"SessionExtend_subheading__MJCE0"};